/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardComponent from './DashboardComponent';

/**
* The DashboardDefinition model module.
* @module model/DashboardDefinition
* @version 2020-12-7
*/
export default class DashboardDefinition {
    /**
    * Constructs a new <code>DashboardDefinition</code>.
    * @alias module:model/DashboardDefinition
    * @class
    * @param title {String} ダッシュボードのタイトル
    * @param components {Array.<module:model/DashboardComponent>} コンポーネント
    */

    constructor(title, components) {
        
        
        this['title'] = title;
        this['components'] = components;
        
    }

    /**
    * Constructs a <code>DashboardDefinition</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DashboardDefinition} obj Optional instance to populate.
    * @return {module:model/DashboardDefinition} The populated <code>DashboardDefinition</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardDefinition();
                        
            
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('components')) {
                obj['components'] = ApiClient.convertToType(data['components'], [DashboardComponent]);
            }
        }
        return obj;
    }

    /**
    * ダッシュボードのタイトル
    * @member {String} title
    */
    'title' = undefined;
    /**
    * コンポーネント
    * @member {Array.<module:model/DashboardComponent>} components
    */
    'components' = undefined;




}
